import { render, staticRenderFns } from "./InsuranceCompanyDelete.vue?vue&type=template&id=ced95984&"
import script from "./InsuranceCompanyDelete.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports